export interface ISCSS_FORMULA {
  amount: number;
  years: number;
  interestRate: number;
}
export const SCSS_FORMULA = ({
  amount,
  years,
  interestRate,
}: ISCSS_FORMULA) => {
  if (amount < 1000 || amount > 1e10) {
    const emptyRes = 0;
    return {
      maturityAmount: emptyRes.toFixed(2),
      quarterlyInterest: emptyRes.toFixed(2),
      totalInterest: emptyRes.toFixed(2),
    };
  }
  const principal = +amount;
  const time = years;
  const rate = interestRate;

  const quarterly = (principal * rate) / 400;
  const interest = quarterly * time * 4;
  const maturity = interest + principal;

  return {
    maturityAmount: maturity.toFixed(2),
    quarterlyInterest: quarterly.toFixed(2),
    totalInterest: interest.toFixed(2),
  };
};
